<template>
  <div
    class="sm:col-span-full flex flex-col"
    v-if="props.adminView && props.editMode"
  >
    <label :style="{color: themedText?.detailText}" :for="model.label" class="text-sm font-medium text-gray-500">{{
      model.label || "fältet saknar rubrik"
    }}</label>
    <textarea
      @input="customChange"
      rows="4"
      :name="model.label"
      :id="model.key"
      v-model="model.data"
      class="mt-1 p-2 block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:py-1.5 sm:text-sm sm:leading-6"
    />
  </div>
  <div class="sm:col-span-full" v-else-if="props.adminView">
    <dt :style="{color: themedText?.detailText}" class="text-sm font-medium text-gray-500">
      {{ model.label || "fältet saknar rubrik" }}
    </dt>
    <dd :style="{color: themedText?.otherText}" class="mt-1 text-sm text-gray-900">
      {{ model.data || "Ingen information angiven." }}
    </dd>
  </div>
  <div class="w-full" v-else>
    <label
      :style="{color: themedText?.otherText}"
      class="block uppercase tracking-wide text-darkGray-1 text-xs font-bold mb-1"
      for="name"
    >
      {{ model.label }}
    </label>
    <div class="relative w-full">
      <textarea
        @input="customChange"
        class="appearance-none block w-full bg-blue-4 text-darkGray-1 placeholder-darkGray-4 border border-blue-4 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-2 disabled:text-darkGray-2 disabled:cursor-not-allowed"
        :id="model.key"
        type="textarea"
        v-model="model.data"
        :placeholder="model.placeholder"
        :required="props.required ? true : null"
        :rows="props.rows ? props.rows : null"
        :disabled="props.disabled ? true : null"
      />

      <div
        :id="'icon-error_' + model.key"
        class="hidden absolute top-0 bottom-0 right-0 left-auto w-[60px] flex flex-row justify-center items-center"
        @mouseenter="showErrorMessage"
        @mouseleave="hideErrorMessage"
      >
        <i class="text-red-2 fa-solid fa-circle-info"></i>
      </div>
    </div>

    <div v-show="showingErrorMessage" class="relative z-50">
      <div
        class="absolute top-0 left-0 right-0 bottom-auto bg-white rounded-md p-2 shadow-md"
        :id="'outer-error_' + model.key"
      >
        <p
          class="font-medium text-sm text-red-2"
          :id="'error_' + model.key"
        ></p>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { defineProps, ref, shallowRef, computed, onMounted } from "vue";
import { defineEmits } from "@vue/runtime-core";
import { useStore } from "vuex";
import { MainContainer } from "@/models/MainContainer";
import { Profile } from "@/models/Profile";
import * as dtos from "@/models/dtos";
const store = useStore();
const containerByDNS = ref<Profile>(null);
const emit = defineEmits(["change"]);
const props = defineProps({
  model: {
    required: false,
  },
  type: String,
  required: {
    type: Boolean,
    required: false,
    default: false,
  },
  rows: {
    type: Number,
    required: false,
    default: 6,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  adminView: {
    type: Boolean,
    required: false,
    default: false,
  },
  editMode: {
    type: Boolean,
    required: false,
    default: false,
  },
});
let model = shallowRef(props.model as dtos.DynamicProperty);
const showingErrorMessage = ref(false);

const showErrorMessage = () => {
  showingErrorMessage.value = true;
};
const hideErrorMessage = () => {
  showingErrorMessage.value = false;
};
function customChange(event: any) {
  emit("change", model.value);
}

onMounted(async () => {
  await store.dispatch("loadContainerTheme");
  try {
    await store.dispatch("loadContainerTheme");
    containerByDNS.value = new Profile(
      new MainContainer(store.getters.publicContainer)
    );
    // isLoaded.value = true;
  } catch (error) {
    console.error("Error loading public container:", error);
  }
});

const themedText = computed(() => store.getters.getContainerThemedText);
</script>
